module.exports = __webpack_public_path__ + "img/logo.fd0bee36.png";